import * as bi from 'react-bootstrap-icons';
import { ClientTicketStatus } from '@bustickus/models-client';
import { Flex } from 'components';
import { Icon } from 'shared/components';
import './style.scss';

interface IProps {
  status: ClientTicketStatus;
  price: number;
}

function TicketStatus(props: IProps) {
  const priceFormatter = new Intl.NumberFormat('ru-RU', {
    style: 'currency',
    currency: 'RUB',
  });

  const price = priceFormatter.format(props.price);

  return (
    <Flex
      className='status-1A5I'
      direction='column'
    >
      {props.status === 'active' && (
        <Flex
          gap={5}
          className='s-4pSB'
        >
          <div>
            <Icon>
              <bi.Check />
            </Icon>
          </div>
          <Flex direction='column'>
            <b>Билет куплен</b>
            <span className='price-6QWU'>
              <b>Цена:</b>
              <span> {price}</span>
            </span>
          </Flex>
        </Flex>
      )}
      {props.status === 'archive' && (
        <Flex
          gap={5}
          className='s-4pSB'
        >
          <div>
            <Icon>
              <bi.Archive />
            </Icon>
          </div>
          <Flex direction='column'>
            <b>Билет в архиве</b>
            <span className='price-6QWU'>
              <b>Цена:</b>
              <span> {price}</span>
            </span>
          </Flex>
        </Flex>
      )}
      {props.status === 'canceled' && (
        <Flex
          gap={5}
          className='e-kRT0'
        >
          <div>
            <Icon>
              <bi.X />
            </Icon>
          </div>
          <Flex direction='column'>
            <b>Покупка отменена</b>
            <span className='price-6QWU'>
              <b>Цена:</b>
              <span> {price}</span>
            </span>
          </Flex>
        </Flex>
      )}
      {props.status === 'refund' && (
        <Flex
          gap={5}
          className='e-kRT0'
        >
          <div>
            <Icon>
              <bi.X />
            </Icon>
          </div>
          <Flex direction='column'>
            <b>Билет возвращён</b>
            <span className='price-6QWU'>
              <b>Цена:</b>
              <span> {price}</span>
            </span>
          </Flex>
        </Flex>
      )}
      {props.status === 'payment_waiting' && (
        <Flex
          gap={5}
          className='w-VGLv'
        >
          <div>
            <Icon>
              <bi.Clock />
            </Icon>
          </div>
          <Flex direction='column'>
            <b>Ожидается оплата...</b>
            <span className='price-6QWU'>
              <b>Цена:</b>
              <span> {price}</span>
            </span>
          </Flex>
        </Flex>
      )}
    </Flex>
  );
}

export default TicketStatus;
